import React from 'react'
import T from 'prop-types'
import { Button, Stack } from '@mui/material'
import { useTranslation } from 'react-i18next'

export default function UploadBar({
  fetchButtonLabel,
  refetchButtonLabel,
  handleFetchData = () => {},
  uploaded,
  readOnly,
}) {
  const { t } = useTranslation()

  return (
    <Stack direction="row" alignItems="center">
      <>
        <Button
          color={uploaded ? 'secondary' : 'primary'}
          variant="contained"
          component="span"
          disabled={readOnly}
          onClick={handleFetchData}
        >
          {uploaded
            ? refetchButtonLabel || t(`common.form.refetchButton`)
            : fetchButtonLabel || t(`common.form.fetchButton`)}
        </Button>
      </>
    </Stack>
  )
}

UploadBar.propTypes = {
  id: T.string,
  fileName: T.string,
  accept: T.array,
  uploadButtonLabel: T.string,
  selectFileButtonLabel: T.string,
  fetchButtonLabel: T.string,
  refetchButtonLabel: T.string,
  handleSelectFile: T.func,
  handleFetchData: T.func,
  showFileUpload: T.bool,
  uploaded: T.bool,
  hideFileName: T.bool,
  readOnly: T.bool,
}
